import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalService } from '../../global/services/global.service';
import { WorkspaceService } from '../../workspace/workspace.service';
import { AppService } from '../../app.service';
import {
  buildHeaderDataShell,
  generalConfigFromGlobal,
  normalizeFilterParams,
  rowPayloadFromActiveScreen,
  hydratedGlobalParams,
} from '../../shared/workspace-element-context';

import { safeJsonInput } from '../../shared/_utils/safe-json-input';
@Component({
    selector: 'gtw-summary-trial-bal-wf',
    templateUrl: './summary-trial-bal-wf.component.html',
    styleUrls: ['./summary-trial-bal-wf.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SummaryTrialBalWfComponent implements OnInit, OnDestroy {
  private readonly subs = new Subscription();

  @Output('request-grid-update') requestGridUpdate = new EventEmitter<string>();

  baseURLs: any = {};
  rowData: any = {};
  filterParams: any = {};
  globalService: any = {};
  GENERAL_CONFIG: any = {};
  userSettings: any = {};

  trailBal: any[] = [];
  showFormLoader = false;
  private isInitialized = false;

  constructor(
    private cdr: ChangeDetectorRef,
    private gtwGlobal: GlobalService,
    private gtwWorkspace: WorkspaceService,
    private gtwApp: AppService
  ) {}

  ngOnInit(): void {
    this.applyWorkspaceContext();
    this.subs.add(
      this.gtwWorkspace.setTabActive.subscribe(() => {
        this.applyWorkspaceContext();
      })
    );
    this.subs.add(
      this.gtwGlobal.globalParamsChanged$.subscribe(() => {
        this.applyWorkspaceContext();
      })
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private applyWorkspaceContext(): void {
    this.isInitialized = false;
    const activeScreen = this.gtwWorkspace.workspaceFactory?.activeScreen || {};
    const header = buildHeaderDataShell(this.gtwGlobal, this.gtwApp);
    header.globalParams = hydratedGlobalParams(this.gtwGlobal, this.gtwWorkspace) || header.globalParams || {};
    this.baseURLs = generalConfigFromGlobal(this.gtwGlobal);
    this.GENERAL_CONFIG = header.generalConfigData || {};
    this.globalService = header;
    this.userSettings = header.userSettingsData || {};
    this.filterParams = normalizeFilterParams(activeScreen);
    this.rowData = rowPayloadFromActiveScreen(activeScreen);
    const tb = activeScreen?.data?.trailBal ?? activeScreen?.data?.trail_bal;
    this.trailBal = this.coerceArray(tb);
    this.tryInit();
    this.cdr.markForCheck();
  }

  private coerceArray(raw: any): any[] {
    if (Array.isArray(raw)) {
      return raw;
    }
    if (typeof raw === 'string') {
      try {
        const p = safeJsonInput<any>(raw || '[]', null, 'summary-trial-bal-wf.parse1');
        return Array.isArray(p) ? p : [];
      } catch {
        return [];
      }
    }
    return [];
  }

  private tryInit(): void {
    if (this.isInitialized) return;
    if (!this.GENERAL_CONFIG || Object.keys(this.GENERAL_CONFIG).length === 0) return;
    this.isInitialized = true;
    if (!Array.isArray(this.trailBal)) {
      this.trailBal = [];
    }
    this.showFormLoader = false;
    this.cdr.detectChanges();
  }

  cancel(): void {
    this.requestGridUpdate.emit('cancel');
  }
}
